import { DemographicInsightPresentationMode } from 'modules/domains/segmentation';
import { CustomDemographicInsightsTable } from './CustomDemographicInsightsTable';
import { useCustomDemographicContext } from './contexts';

export const CustomDemographicInsightsSection = () => {
  const { cachedCustomDemograhpicInsights, isCustomDemographicInsightLoading } =
    useCustomDemographicContext();

  return (
    <>
      {cachedCustomDemograhpicInsights.length > 0 &&
        cachedCustomDemograhpicInsights.map(({ contactProperty, values, mode }) => {
          const hasChart = mode === DemographicInsightPresentationMode.TableAndChart;
          return (
            <CustomDemographicInsightsTable
              title={contactProperty}
              key={contactProperty}
              customInsight={values}
              hasChart={hasChart}
              isLoading={isCustomDemographicInsightLoading}
            />
          );
        })}
    </>
  );
};
